import { SectionMessage, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const UmbrellaOrganizationsInvitationsSectionWrapper = styled.section`
  margin-bottom: ${Spacing.S24};
`

export const InfoSection = styled(SectionMessage)`
  margin-bottom: ${Spacing.S24};
`
